// gatsby-browser.js
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Global styles
import "./src/styles/global.css";

// Scroll to top on route change
export const onRouteUpdate = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
